import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReceivedOffersState } from "./models/receivedOffersModels";
import receivedOffersApi from "./api/receivedOffersApi";

export const getReceivedOffers = createAsyncThunk(
  "receivedOffersSlice/getReceivedOffers",
  async (serviceRequestId: string) => {
    return receivedOffersApi.getReceivedOffers(serviceRequestId);
  }
);

export const acceptOffer = createAsyncThunk(
  "receivedOffersSlice/acceptOffer",
  async ({
    serviceRequestId,
    offerId,
  }: {
    serviceRequestId: string;
    offerId: string;
  }) => {
    return receivedOffersApi.acceptOffer(serviceRequestId, offerId);
  }
);

export const rejectOffer = createAsyncThunk(
  "receivedOffersSlice/rejectOffer",
  async ({
    serviceRequestId,
    offerId,
    reason,
  }: {
    serviceRequestId: string;
    offerId: string;
    reason?: string;
  }) => {
    return receivedOffersApi.rejectOffer(serviceRequestId, offerId, reason);
  }
);

export const cancelAcceptance = createAsyncThunk(
  "receivedOffersSlice/cancelAcceptance",
  async ({
    serviceRequestId,
    offerId,
  }: {
    serviceRequestId: string;
    offerId: string;
  }) => {
    return receivedOffersApi.cancelAcceptance(serviceRequestId, offerId);
  }
);

const initialState: ReceivedOffersState = {
  receivedOffers: undefined,
  loading: false,
  actionLoading: false,
  error: undefined,
};

const receivedOffersSlice = createSlice({
  name: "receivedOffersSlice",
  initialState,
  reducers: {
    clearReceivedOffers: (state) => {
      state.receivedOffers = undefined;
    },
    clearError: (state) => {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      // getReceivedOffers
      .addCase(getReceivedOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReceivedOffers.fulfilled, (state, { payload }) => {
        state.receivedOffers = payload;
        state.loading = false;
      })
      .addCase(getReceivedOffers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      })
      // acceptOffer
      .addCase(acceptOffer.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(acceptOffer.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(acceptOffer.rejected, (state, { error }) => {
        state.error = error;
        state.actionLoading = false;
      })
      // rejectOffer
      .addCase(rejectOffer.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(rejectOffer.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(rejectOffer.rejected, (state, { error }) => {
        state.error = error;
        state.actionLoading = false;
      })
      // cancelAcceptance
      .addCase(cancelAcceptance.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(cancelAcceptance.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(cancelAcceptance.rejected, (state, { error }) => {
        state.error = error;
        state.actionLoading = false;
      });
  },
});

export const { clearReceivedOffers, clearError } = receivedOffersSlice.actions;
export default receivedOffersSlice.reducer;
